import React from "react";
import { FormGroup, Radio, RadioGroup } from "@blueprintjs/core";
import { DpmsTypes } from 'csd.phoenix.models/DpmsTypes';
import { IFieldOption } from "../../shared/form/models";
import css from "./styles.module.scss";

interface IDpmsFilterGroupProps {
  dpmsList: IFieldOption[];
  selectedValue?: DpmsTypes;
  disabled: boolean;
  onChange: (e: React.FormEvent<HTMLInputElement>) => void;
}

const DpmsFilterGroup: React.FC<IDpmsFilterGroupProps> = ({ dpmsList, selectedValue, disabled, onChange }) => {
  // Show "Any" option only when multiple DPMS types are available (e.g., US env)
  // Hide it when only one type exists (e.g., R4-only UK env)
  const showAnyOption = dpmsList.length > 1;

  // Step 1: Build all radio options in a single flat array
  const radioOptions: JSX.Element[] = [];

  // Add "Any" option at the beginning if needed
  if (showAnyOption) {
    radioOptions.push(<Radio key="any" value="">Any</Radio>);
  }

  // Add each DPMS type as a radio option
  dpmsList.forEach(dpms => {
    radioOptions.push(
      <Radio key={String(dpms.value)} value={dpms.value as number}>
        {dpms.text}
      </Radio>
    );
  });

  // Step 2: Distribute radio options evenly across 3 columns for better layout
  const totalOptions = radioOptions.length;
  const itemsPerColumn = Math.ceil(totalOptions / 3);  // Round up to ensure all fit
  const columns: JSX.Element[] = [];

  // Create a RadioGroup for each column with its slice of options
  for (let i = 0; i < totalOptions; i += itemsPerColumn) {
    const columnRadios = radioOptions.slice(i, i + itemsPerColumn);
    columns.push(
      <RadioGroup
        key={`dpms-col-${columns.length}`}
        disabled={disabled}
        className="column"
        selectedValue={selectedValue ?? ""}
        onChange={onChange}>
        {columnRadios}
      </RadioGroup>
    );
  }

  return (
    <FormGroup className="column">
      <div className={css.formGroupLabel}>DPMS</div>
      <div className="columns">
        {columns}
      </div>
    </FormGroup>
  );
};

export default DpmsFilterGroup;
